"use client"

import { AlignVerticalDistributeStart } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AlignVerticalDistributeStartIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AlignVerticalDistributeStartIcon = component(Icon)({
  as: AlignVerticalDistributeStart,
})
